import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

export type Data = OopsyData;

const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.SaintMociannesArboretumHard,
  damageWarn: {
    'St Mocianne Hard Mudstream': '30D9', // Targeted circle AoE, Immaculate Apa trash, before boss 1
    'St Mocianne Hard Silken Spray': '3385', // Rear cone AoE, Withered Belladonna trash, before boss 1
    'St Mocianne Hard Muddy Puddles': '30DA', // Small targeted circle AoEs, Dorpokkur trash, before boss 1
    'St Mocianne Hard Odious Air': '2E49', // Frontal cone AoE, Nullchu, boss 1
    'St Mocianne Hard SLudge Bomb': '2E4E', // Targeted circle AoEs, Nullchu, boss 1
    'St Mocianne Hard Odious Atmosphere': '2E51', // Channeled 3/4 arena cleave, Nullchu, boss 1
    'St Mocianne Hard Creeping Ivy': '31A5', // Frontal cone AoE, Withered Kulak trash, before boss 2
    'St Mocianne Hard Rockslide': '3134', // Line AoE, Silt Golem, boss 2
    'St Mocianne Hard Earthquake Inner': '312E', // Chariot AoE, Lakhamu, boss 2
    'St Mocianne Hard Earthquake Outer': '312F', // Dynamo AoE, Lakhamu, boss 2
    'St Mocianne Hard Embalming Earth': '31A6', // Large Chariot AoE, Muddy Mata, after boss 2
    'St Mocianne Hard Quickmire': '3136', // Sewage surge avoided on platforms, Tokkapchi, boss 3
    'St Mocianne Hard Quagmire Platforms': '3139', // Quagmire explosion on platforms, Tokkapchi, boss 3
    'St Mocianne Hard Feculent Flood': '313C', // Targeted thin cone AoE, Tokkapchi, boss 3
    'St Mocianne Hard Corrupture': '33A0', // Mud Slime explosion, boss 3. (No explosion if done correctly.)
  },
  gainsEffectWarn: {
    'St Mocianne Hard Seduced': '3DF', // Gaze failure, Withered Belladonna trash, before boss 1
    'St Mocianne Hard Pollen': '13', // Sludge puddles, Nullchu, boss 1
    'St Mocianne Hard Transfiguration': '648', // Roly-Poly AoE circle failure, BLooming Biloko trash, before boss 2
    'St Mocianne Hard Hysteria': '128', // Gaze failure, Lakhamu, boss 2
    'St Mocianne Hard Stab Wound': '45D', // Arena outer wall effect, boss 2
  },
  shareWarn: {
    'St Mocianne Hard Taproot': '2E4C', // Large orange spread circles, Nullchu, boss 1
    'St Mocianne Hard Earth Shaker': '3131', // Earth Shaker, Lakhamu, boss 2
  },
  soloFail: {
    'St Mocianne Hard Fault Warren': '2E4A', // Stack marker, Nullchu, boss 1
  },
};

export default triggerSet;
